import React, { useState } from 'react';
import { Field } from 'react-final-form';
import Icon from '@/components/ui/Icon';

interface PasswordFieldProps {
  displayError?: boolean;
  htmlFor: string;
  inputWidth?: number;
  isHorizontal?: boolean;
  label: string;
  labelWidth?: number;
}

// This component creates an input styled like the Rails views,
// to make the different password/sign-in forms look consistent.
const PasswordField = ({
  displayError = true,
  htmlFor,
  inputWidth = 230,
  isHorizontal = true,
  label,
  labelWidth = 130,
  ...fieldProps
}: PasswordFieldProps) => {
  const [inputType, setInputType] = useState('password');
  const isPasswordInput = inputType === 'password';
  const labelMargin = 8;
  const labelWidthMinusMargin = labelWidth - labelMargin;

  return (
    <Field name={htmlFor} type={inputType} {...fieldProps}>
      {({ input, meta }) => (
        <div className="tw-flex tw-flex-col tw-py-1 tw-mb-1">
          <div className={`tw-flex  ${isHorizontal ? 'tw-items-center' : 'tw-flex-col'}`}>
            <label
              className="tw-font-bold tw-overflow-visible"
              htmlFor={htmlFor}
              style={{
                marginRight: `${labelMargin}px`,
                minWidth: `${labelWidthMinusMargin}px`,
                width: `${labelWidthMinusMargin}px`,
              }}
            >
              {label}
            </label>

            <div className="tw-flex tw-items-center">
              <input
                {...input}
                className={`tw-h-[26px] tw-px-1 tw-py-0 tw-overflow-hidden tw-relative
                  tw-border tw-border-solid tw-rounded-md ${
                    meta.error && meta.submitFailed ? 'tw-border-red' : 'tw-border-[#ccc]'
                  }`}
                id={htmlFor}
                style={{ width: `${inputWidth}px` }}
                type={inputType}
              />
              <button
                aria-label={`Toggle password ${isPasswordInput ? 'visible' : 'hidden'}`}
                className="tw-ml-2 tw-p-0 tw-cursor-pointer tw-border-none tw-bg-transparent"
                type="button"
                onClick={() => setInputType(isPasswordInput ? 'text' : 'password')}
              >
                <Icon
                  fill={isPasswordInput ? '#777770' : '#522e91'}
                  icon={isPasswordInput ? 'Hide' : 'Observe'}
                  size={16}
                />
              </button>
            </div>
          </div>

          {displayError && meta.error && meta.submitFailed && (
            <div
              className="tw-text-red tw-text-sm tw-mt-1"
              style={{ marginLeft: `${labelWidth}px` }}
            >
              {meta.error}
            </div>
          )}
        </div>
      )}
    </Field>
  );
};

export default PasswordField;
